import { ErrorMessage, Field, Form, Formik } from 'formik';
import moment from 'moment';
import React, { useEffect } from 'react';
import { BiAlarm, BiHelpCircle } from 'react-icons/bi';
import { MdOutlineFileCopy } from 'react-icons/md';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Button } from 'reactstrap';
import * as Yup from 'yup';

const schema = Yup.object().shape({
  UTR: Yup.string()
    .required('Please Enter UTR number')
    .min(12, 'UTR must be 12')
    .max(12, 'UTR must be 12')
});

const InfoForm = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const data = JSON.parse(atob(id));

  useEffect(() => {
    document.title = data?.ap;
    if (data?.e < moment().unix()) return navigate('/expire');
  }, [navigate, data?.e, data?.ap]);

  const handleCopy = (data) => {
    navigator.clipboard.writeText(data);
    toast.info('Copied Successfully');
  };

  return (
    <div className='container-sm' style={{ maxWidth: '700px' }}>
      <div className='head'>
        <BiAlarm size={'4rem'} />
        <h1>{data.ap}</h1>
      </div>
      <h5 className='pink'>Please pay within 1 hour</h5>
      <div className='box'>
        <div className='box-head'>
          <p>
            <span className='green'>Step 1: </span>
            Copy UPI information
          </p>
        </div>
        <div className='box-body'>
          <div className='box-info'>
            <p>Amout</p>
            <p className='pink'>{data?.a}</p>
          </div>
          <button className='copy-btn' onClick={() => handleCopy(data?.a)}>
            <MdOutlineFileCopy /> Copy
          </button>
        </div>
        <div className='box-body'>
          <div className='box-info'>
            <p>Your Name (Check your name before paying)</p>
            <p className='pink'>{data?.u}</p>
          </div>
        </div>
        <div className='box-body'>
          <div className='box-info'>
            <p>UPI ID / VPA ID</p>
            <p className='pink'>{data?.up}</p>
          </div>
          <button className='copy-btn' onClick={() => handleCopy(data?.up)}>
            <MdOutlineFileCopy /> Copy
          </button>
        </div>
        <div className='bg-pink'>
          <p>
            <span className='yellow'>Important: </span> UPI cannot be modified,
            if modified, the payment will be unsuccessfull (Not a single
            character will be changed)
          </p>
        </div>
        <div className='box-body'>
          <div className='box-info'>
            <p>Leave Message on pay (important) speed up money arrival</p>
            <p className='pink'>I-IOLOPEM</p>
          </div>
          <button className='copy-btn' onClick={() => handleCopy(data.up)}>
            <MdOutlineFileCopy /> Copy
          </button>
        </div>
        <div className='box-head'>
          <p>
            <span className='green'>Step 2: </span>
            Open your UPI/wallet/Payment bank app & use the above UPI ID for
            your payment.
          </p>
        </div>
        <div className='box-head'>
          <p>
            <span className='bg-green'>! !</span>{' '}
            <span className='green'>Step 3:</span>
            Please enter Ref No to complete the recharge{' '}
            <span className='green'>(IMPORTANT)</span>
          </p>
          <p className='help'>
            <BiHelpCircle />
            <spam>Help</spam>
          </p>
        </div>
      </div>
      <Formik
        initialValues={{ UTR: '' }}
        validationSchema={schema}
        onSubmit={() => {
          navigate('/success');
        }}
      >
        {() => (
          <Form>
            <Field name='UTR' className='form-control text-ellipsis mt-2' />
            <ErrorMessage component='div' name='UTR' style={{ color: 'red' }} />
            <Button type='submit' className='mt-2 submit-btn'>
              Submit UTR
            </Button>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default InfoForm;
